
<template>
    <div class="footerBottom">
        <div class="flx-center">
            <div class="globelBackground" :style="{ background: 'url(' + $ossUrl + 'images/智联全球.jpg) no-repeat center'  }" ></div>
        </div>
        <div class="container">
            <div ref="globelTitleBox" class="globelTitleBox flx-wrap " :style="`position: absolute;top:${700}px;`">
             <div class="globelTitle">简介</div>
             <div class="globelContent">美通设立国内分公司20家，每家分公司都建立了周转和存储仓，目前已经形成华南、华东、华北、华中四大分拨中心，未来还会将集散网络延伸到内地，建立全国性的仓储分拨网络。海外另设20家分公司，建自营/联营全球清关转运中心，为客户创造更好的物流体验。
             </div>
           </div>
          <div class="echartsBox" style="">
            <div class="ChinaMap" >
                   <chinaMap></chinaMap>
           </div>
           <div class="echartsContent" >
            <div class="flx-justify-end" style="margin-bottom: 40px;">
                <img :src="$ossUrl+'icons/listen.png'">
            </div>
            <div>
            立足本地收货，本地集散。美通在全国每家分公司都建立了周转和存储仓，目前已经形成华南、华东、华中、华北四大分拨中心，未来还会将集散网络延伸到内地，建立全国性的仓储分拨网络。
            </div>
        </div>
          </div>
          <div>
            <div class="companyAddress">
                国内分公司地址
            </div>
            <el-row>
                <el-col v-for="(item,index) in companyList" :key="index" :span="12">
                    <div class="companyBox ">
                        <div class="companyTitle">{{item.title}}</div>
                          <div class="companyContent">
                                <div v-for="(itemData,indexData) in item.contentList" :key="indexData"> {{itemData.content}}</div>
                            </div>
                    </div>
                </el-col>
            
                
            </el-row>
          </div>
          <div>
            <div class="companyAddress">
                国外分公司地址
            </div>
            <el-row>
                <el-col v-for="(item,index) in overCompanyList" :key="index" :span="12">
                    <div class="companyBox ">
                        <div class="companyTitle">
                            <div v-if="item.contentList[0].content !== ''"> {{item.title}}</div>
                            <div v-else class="flx-justify-between " style="line-height:90px"> 
                                <span>{{item.title}}</span>
                            </div>
                        </div>
                          <div class="overCompanyContent">
                                <div v-for="(itemData,indexData) in item.contentList" :key="indexData"> {{itemData.content}}</div>
                            </div>
                    </div>
                </el-col>
            
                
            </el-row>
          </div>
        </div>
    </div>
      
     
  </template>
  <script>
  import chinaMap from './chinaMap.vue';
  export default {
    name:"globalNetwork",
    components: {
        chinaMap
      // Switcher
    },
    created() {
    
    },
    mounter(){
        this.setTopPosition();
    },
    data() {
      return {
       newsList:[
        {
          id:'1',
          title:'喜报！热烈祝贺美通荣获亚马逊“2023金牌辅助”和“SPN一年级奖”通.祝贺美通荣获亚马逊“2023金牌辅助”和“SPN一年级前...',
          time:'2023-03-01 16:10',
          company:'美通供应链',
          img:this.$ossUrl+'images/news/newsIndex/people.png',
        },
        {
          id:'2',
          title:'喜报！热烈祝贺美通荣获亚马逊“2023金牌辅助”和“SPN一年级奖”通.祝贺美通荣获亚马逊“2023金牌辅助”和“SPN一年级前...',
          time:'2023-03-01 16:10',
          company:'美通供应链',
          img:this.$ossUrl+'images/news/newsIndex/people.png',
        },
       ],
       companyList:[
        {
            title:'深圳总部',
            contentList:[
                {
                    content:'深圳市龙岗区坂田五和大道南路49号金方华电商产业园9栋105',
                },
                {
                  content:'深圳市龙岗区雅园路26号坂银谷A1001-A1004',
                }
            ]
        },
        {
            title:'机场分部',
            contentList:[
                {
                    content:'深圳市宝安区福永街道怀德国际大厦1501-04'
                }
            ]
        },
        {
            title:'观澜分部',
            contentList:[
                {
                    content:'深圳市龙华区观澜街道牛湖社区观天路17号大地城红木市场'
                }
            ]
        },
        {
            title:'广州分公司',
            contentList:[
                {
                    content:'广州市白云区彭上科技产业园F座202-206'
                }
            ]
        },
        {
            title:'中山分公司',
            contentList:[
                {
                    content:'中山东区利和国际金融中心4701-03'
                }
            ]
        },
        {
            title:'佛山分公司',
            contentList:[
                {
                    content:'佛山市顺德区顺联智造汇18座首层118-125号铺'
                }
            ]
        },
        {
            title:'东莞分公司',
            contentList:[
                {
                    content:'东莞市南城街道寰宇汇金中心9栋A座3503室'
                }
            ]
        },
        {
            title:'上海分公司',
            contentList:[
                {
                    content:'上海市松江区寅西路358号A栋606-607室'
                }
            ]
        },
        {
            title:'义乌分公司',
            contentList:[
                {
                    content:'浙江省义乌市北苑街道春晗路129号博尼产业园1号楼5号（美通供应链）'
                }
            ]
        },
        {
            title:'郑州分公司',
            contentList:[
                {
                    content:'郑州市管城回族区文治路20号云时代广场2-368室'
                }
            ]
        },
        {
            title:'青岛分公司',
            contentList:[
                {
                    content:'浙江省义乌市北苑街道春晗路129号博尼产业园1号楼5号（美通供应链）'
                }
            ]
        },
        {
            title:'合肥分公司',
            contentList:[
                {
                    content:'郑州市管城回族区文治路20号云时代广场2-368室'
                }
            ]
        },
        {
            title:'宁波分公司',
            contentList:[
                {
                    content:'浙江省义乌市北苑街道春晗路129号博尼产业园1号楼5号（美通供应链）'
                }
            ]
        },
        {
            title:'长沙分公司',
            contentList:[
                {
                    content:'郑州市管城回族区文治路20号云时代广场2-368室'
                }
            ]
        },
        {
            title:'厦门分公司',
            contentList:[
                {
                    content:'中山东区利和国际金融中心4701-03'
                }
            ]
        },
        {
            title:'成都分公司',
            contentList:[
                {
                    content:'中山东区利和国际金融中心4701-03'
                }
            ]
        }
       ],
       overCompanyList:[
        {
            title:'美国',
            contentList:[
                {
                    content:'洛杉矶/纽约/芝加哥分公司'
                }
            ]
        },
        {
            title:'英国',
            contentList:[
                {
                    content:'伦敦/菲利克斯托分公司'
                }
            ]
        },
        {
            title:'比利时',
            contentList:[
                {
                    content:'列日分公司'
                }
            ]
        },
        {
            title:'法国',
            contentList:[
                {
                    content:'巴黎分公司'
                }
            ]
        },
        {
            title:'德国',
            contentList:[
                {
                    content:'法兰克福/杜伊斯堡分公司'
                }
            ]
        },
        {
            title:'加拿大',
            contentList:[
                {
                    content:'温哥华/多伦多分公司'
                }
            ]
        },
        {
            title:'日本',
            contentList:[
                {
                    content:'东京/大阪分公司'
                }
            ]
        },
        {
            title:'墨西哥',
            contentList:[
                {
                    content:'墨西哥城'
                }
            ]
        },
        {
            title:'俄罗斯',
            contentList:[
                {
                    content:''
                }
            ]
        }
       ],
       boxStyle: null
      };
    },
    methods: {
        setTopPosition() {
              const globelContent = this.$refs.globelTitleBox.querySelector('.globelContent');
              const topValue = globelContent.offsetHeight / 2; // 获取50%的高度
              this.boxStyle =topValue
            }
    }
    
  };
  </script>
  <style src="./index.css" scoped>
  
  
  </style>